<template>
<body id="page-top" class="member-page-body">
        <!-- Navigation-->
        <nav class="navbar navbar-expand-lg bg-secondary text-uppercase fixed-top" id="mainNav">
            <div class="container">
                <img class="navbar-brand" href="#page-top" src="../assets/philcare-logo.png"/>
                    <i class="fas fa-bars"></i>
            </div>
        </nav>
        <section class="page-section portfolio member-page-section" id="portfolio">
            <div class="container">
                <div class="row justify-content-center">
                    <div>
                        <p class="h2 page-title">Find a Doctor</p>
                    </div>
                </div>
                
                <div class="row justify-content-center phil-row-info doctor-row">
                    <div class="col-4">
                        <p><strong>Specialization:</strong></p>
                      </div>
                      <div class="col-8">
                        <form autocomplete="off" class="form-inline" @submit.prevent="handleSearch">
                  <select ref="firstInput" v-model="Specialization" class="form-select phil-specialization-select" aria-label="Default select example">
                    <option :value="item.Specialization" v-for="item in Specializations" :key="item.SpecCode">{{item.Specialization}}</option>
                  </select>
                  <button class="btn btn-outline-success my-2 my-sm-0  phil-specialization-button" type="submit">Search</button>
                </form>
                      </div>
                      <div class="col-md-12">
                    <div class="list-group scroll">
                      <a v-if="Doctors.length == 0" style="font-size:30px;">Please select a Specialization.</a>
                        <a v-else-if="Doctors.length != 0" href="#" class="list-group-item list-group-item-action" v-for="item in Doctors" :key="item.DoctorCode" >
                        {{item.DoctorName}}<br>
                        {{item.Specialization}}<br>
                        {{item.TelNo}}
                      </a>
                    </div>
                
                  </div>
                </div>

            
            <div class="row justify-content-center">
                <div class="col-md-12">
                    <router-link to="/find-a-doctor"><button class="btn btn-primary btn-lg" style="margin-top: 25px;">BACK</button></router-link>
                </div>
            </div>
        </div>
        </section>
        <div class='spinner load' v-if='loading'><img src="../assets/phil-care-loading-logo.gif"/></div>
</body>
</template>

<script>
import axios from 'axios';
export default {
  name: 'DoctorName',
  data() {
    return {
      certNo: '',
      TokenID: '',
      Specialization:'',
      Doctors: [],
      Specializations: [],
      error: false,
      loading: false,


    }
  },
  methods: {
    async handleSearch() {
      this.loading = true
      console.log(this.Specialization);
      this.TokenID = localStorage.getItem('TokenID')
      this.certNo = localStorage.getItem('CertNo')
        const response = await axios.post('/api/?action=member-doctor-name', {
           TokenID: this.TokenID,
           Specialization: this.Specialization,
           ProviderCode: localStorage.getItem('setProvider'),
           CertNo: this.certNo
        }, 
        );

        console.log(response);
        this.Doctors=response.data
        this.loading = false

        
        
    }
    
  },

  async created() {
    if (localStorage.getItem('CertNo') === null) {
          this.$router.push('/login');
      }
      this.TokenID = localStorage.getItem('TokenID')
        const response = await axios.post('/api/?action=doctor-specialization', {
           TokenID: this.TokenID,
           Specialization: this.Specialization
        }, 
        );

        console.log(response);
        this.Specializations=response.data
  },
  mounted() {
    this.$refs.firstInput.focus();
  }
  }



</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
